import React from 'react'
import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControlLabel,
    IconButton,
    Stack,
    Switch,
    Typography,
} from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import {
    toggleDarkMode,
    toggleFullWidthUi,
    toggleMui5Breakpoints,
    toggleOfferDialogV2,
    toggleMswEnabled,
    useDarkMode,
    useFullWidthUi,
    useMui5Breakpoints,
    useOfferDialogV2,
    useMswEnabled,
} from '@edge/spark/io-roles'

interface ExperimentDialogProps {
    open: boolean
    onClose: () => void
}

export const ExperimentTogglesDialog: React.VFC<ExperimentDialogProps> = ({ open, onClose }: ExperimentDialogProps) => {
    const darkMode = useDarkMode()
    const fullWidthUi = useFullWidthUi()
    const mui5Breakpoints = useMui5Breakpoints()
    const offerDialogV2 = useOfferDialogV2()
    const mswEnabled = useMswEnabled()

    return open ? (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle sx={{ m: 0, p: 2 }}>
                <Typography variant="h6">Experiments</Typography>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ minWidth: '300px' }}>
                <DialogContentText sx={{ marginBottom: 2 }}>
                    <span style={{ color: 'red' }}>WARNING:</span> These experiments could be unstable or unreliable and
                    may require you to restart SPARK.
                </DialogContentText>
                <Stack>
                    <FormControlLabel
                        control={<Switch />}
                        label="Mui5 Breakpoints"
                        onChange={toggleMui5Breakpoints}
                        checked={mui5Breakpoints}
                    />
                    <FormControlLabel
                        control={<Switch />}
                        label="Full Width UI"
                        onChange={toggleFullWidthUi}
                        checked={fullWidthUi}
                    />
                    <FormControlLabel
                        control={<Switch />}
                        label="Dark Mode"
                        onChange={toggleDarkMode}
                        checked={darkMode}
                    />
                    <FormControlLabel
                        control={<Switch />}
                        label="Offer Dialog V2"
                        onChange={toggleOfferDialogV2}
                        checked={offerDialogV2}
                    />
                    <FormControlLabel
                        control={<Switch />}
                        label="Testing Tools"
                        onChange={toggleMswEnabled}
                        checked={mswEnabled}
                    />
                </Stack>
            </DialogContent>
        </Dialog>
    ) : null
}
